import { Box, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface TestTemplateInUseDialogProps {
  onClose: () => void
}

const TestTemplateInUseDialog: FC<TestTemplateInUseDialogProps> = ({ onClose }) => {
  return (
    <Dialog open onClose={onClose} data-testid='test-template-in-use-dialog'>
      <DialogContent classes={{ root: "p-10" }}>
        <Box className='mb-6 w-full justify-center text-center'>
          <WarningOutlined className='size-[48px] text-secondary-600' />
          <Typography data-testid='title' variant='h5' color='primary' className='mt-6 font-normal' component='h2'>
            Cannot Edit Test Template While In Use
          </Typography>
        </Box>
        <Typography
          data-testid='content'
          variant='h6'
          className='mt-6 px-3 text-center text-base leading-[150%] tracking-[-0.85px] text-gray-700'
          component='div'
        >
          To make changes to this template, first remove all associated products.
          <br />
          Editing is only allowed when the template is not linked to any products.
        </Typography>
      </DialogContent>
      <DialogActions className='justify-end px-10 pb-10 pt-0'>
        <Button data-testid='submit-button' variant='primary' onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TestTemplateInUseDialog
